import axios from 'axios';
import { domain } from './domain';

export const createFood = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
        data
    };
    return axios(domain + '/food', requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            } else {
                throw new Error('Bağlantı hatası!');
            }
        })
        .catch((error) => {
            return error;
        });
};

export const updateFood = (token, data) => {
    const requestOptions = {
        method: 'PUT',
        headers: { 
            'Content-type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
        data
    };
    return axios(domain + '/food', requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            } else {
                throw new Error('Bağlantı hatası!');
            }
        })
        .catch((error) => {
            return error;
        });
};

export const getFoods = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-type': 'application/json',
        },
        data
    };
    return axios(domain + '/getfoods', requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            } else {
                throw new Error('Bağlantı hatası!');
            }
        })
        .catch((error) => {
            return error;
        });
};

export const createMeal = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
        data
    };
    return axios(domain + '/mealcoach', requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            } else {
                throw new Error('Bağlantı hatası!');
            }
        })
        .catch((error) => {
            return error;
        });
};

export const updateMeal = (token, data) => {
    const requestOptions = {
        method: 'PUT',
        headers: { 
            'Content-type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
        data
    };
    return axios(domain + '/mealcoach', requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            } else {
                throw new Error('Bağlantı hatası!');
            }
        })
        .catch((error) => {
            return error;
        });
};

export const getMeals = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-type': 'application/json',
        },
        data
    };
    return axios(domain + '/getmeals', requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            } else {
                throw new Error('Bağlantı hatası!');
            }
        })
        .catch((error) => {
            return error;
        });
};

export const createUserMeal = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
        data
    };
    return axios(domain + '/usermealcoach', requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            } else {
                throw new Error('Bağlantı hatası!');
            }
        })
        .catch((error) => {
            return error;
        });
};

export const updateUserMeal = (token, data) => {
    const requestOptions = {
        method: 'PUT',
        headers: { 
            'Content-type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
        data
    };
    return axios(domain + '/usermealcoach', requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            } else {
                throw new Error('Bağlantı hatası!');
            }
        })
        .catch((error) => {
            return error;
        });
};

export const getUserMeals = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-type': 'application/json',
        },
        data
    };
    return axios(domain + '/getusermeals', requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            } else {
                throw new Error('Bağlantı hatası!');
            }
        })
        .catch((error) => {
            return error;
        });
};


export const createNutrition = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
        data
    };
    return axios(domain + '/nutritioncoach', requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            } else {
                throw new Error('Bağlantı hatası!');
            }
        })
        .catch((error) => {
            return error;
        });
};

export const updateNutrition = (token, data) => {
    const requestOptions = {
        method: 'PUT',
        headers: { 
            'Content-type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
        data
    };
    return axios(domain + '/nutritioncoach', requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            } else {
                throw new Error('Bağlantı hatası!');
            }
        })
        .catch((error) => {
            return error;
        });
};

export const getNutritions = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-type': 'application/json',
        },
        data
    };
    return axios(domain + '/getnutritions', requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            } else {
                throw new Error('Bağlantı hatası!');
            }
        })
        .catch((error) => {
            return error;
        });
};

export const createUserNutrition = (token, data) => {
    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
        data
    };
    return axios(domain + '/usernutritioncoach', requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            } else {
                throw new Error('Bağlantı hatası!');
            }
        })
        .catch((error) => {
            return error;
        });
};

export const updateUserNutrition = (token, data) => {
    const requestOptions = {
        method: 'PUT',
        headers: { 
            'Content-type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
        data
    };
    return axios(domain + '/usernutritioncoach', requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            } else {
                throw new Error('Bağlantı hatası!');
            }
        })
        .catch((error) => {
            return error;
        });
};

export const getUserNutritions = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-type': 'application/json',
        },
        data
    };
    return axios(domain + '/getusernutritions', requestOptions)
        .then((response) => {
            if (response.data.code) {
                return response;
            } else {
                throw new Error('Bağlantı hatası!');
            }
        })
        .catch((error) => {
            return error;
        });
};